// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"45":"TabsFilter","90":"wix-bookings-services-preferences-modal","342":"DropdownFilter","662":"TagsFilter","973":"FilterPanel"}[chunkId] || chunkId) + ".chunk.min.css";
};